import {
    DIC
} from '@/const/dic'
import {
    validateChinese
} from '@/util/validate'
import {
    formatterTime
} from '@/util/util'

export const distributionAreaOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [
        {
            label: '经销商名称',
            prop: 'distributorName',
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: '账号',
            prop: 'account',
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: '经销商',
            prop: 'distributorId',
            formsolt: true,
            hide: true,
        },
        {
            label: "配送区域名称",
            prop: "distributionAreaName",
            type: "input",
        },
        {
            label: "省",
            prop: "province",
            formsolt: true
        },
        {
            label: "市",
            prop: "city",
            formsolt: true
        },
        {
            label: "区",
            prop: "area",
            formsolt: true
        }, {
            label: "详细地址",
            prop: "address",
            type: "input"
        },

        {
            label:"标记位置",
            prop:'provinces',
            hide: true,
            // span: 24,
            // solt: true,
            formsolt: true
        },
        {
            label: "配送半径",
            prop: "radius",
            type: "input",
        }
    ]
};